import { api } from './api';
import type {
  UserProfile,
  UpdateProfileInput,
  UpdateUserInfoInput,
  ChangePasswordInput,
  CompleteUser,
} from '../types/profile';

/**
 * Get current user's complete profile
 */
export const getCurrentUser = async (): Promise<CompleteUser> => {
  const response = await api.get('/api/users/me');
  return response.data.data;
};

/**
 * Get user's profile
 */
export const getUserProfile = async (): Promise<UserProfile> => {
  const response = await api.get('/api/users/profile');
  return response.data.data;
};

/**
 * Update user's profile
 */
export const updateUserProfile = async (data: UpdateProfileInput): Promise<UserProfile> => {
  const response = await api.put('/api/users/profile', data);
  return response.data.data;
};

/**
 * Update user's basic info (name, email)
 */
export const updateUserInfo = async (data: UpdateUserInfoInput): Promise<CompleteUser> => {
  const response = await api.put('/api/users/info', data);
  return response.data.data;
};

/**
 * Change user's password
 */
export const changePassword = async (data: ChangePasswordInput): Promise<void> => {
  await api.post('/api/users/change-password', data);
};

/**
 * Delete user account
 */
export const deleteUserAccount = async (password: string): Promise<void> => {
  await api.delete('/api/users/account', {
    data: { password },
  });
};
